import React from "react";
import { decode } from "html-entities";
import { Link } from "react-router-dom";
import { getUploadsUrl } from "../../config";

export default function BlogFeature({ post }) {
    if (!post) {
        return (
            <section className="container sec-blog-feature">
                <div className="blog-feature card skeleton">
                    <div className="txt">
                        <span className="kicker placeholder-line small" />
                        <h2 className="placeholder-line title" />
                        <p className="placeholder-line" />
                        <span className="go placeholder-line tiny" />
                    </div>
                    <div className="art graphic">
                        <div className="blob placeholder-box"></div>
                        <span className="dots"></span>
                    </div>
                </div>
            </section>
        );
    }

    const img = post.feature_image_url;
    const slug = post.slug || "";

    return (
        <section className="container sec-blog-feature">
            <Link to={`/blog/${slug}`} className="blog-feature card">
                <div className="txt">
                    {post.category_name && post.category_name.toLowerCase() !== "uncategorized" && (
                        <span className="kicker">FEATURED · {decode(post.category_name).toUpperCase()}</span>
                    )}
                    <h2>{decode(post.title)}</h2>
                    <p>{decode(post.short_description)}</p>
                    <span className="go">Read article →</span>
                </div>
                <div className="art graphic">
                    {img ? (
                        <img loading="lazy" src={getUploadsUrl('posts', img)} alt={post.feature_image_name || post.title} />
                    ) : (
                        <span className="blob blob-banner1"></span>
                    )}
                    <span className="dots"></span>
                </div>
            </Link>
        </section>
    );
}
